export default {
    name: 'CheckmarkCircleFilled',
    dimensions: { width: 41, height: 41 },
    content: `
    <path d="M20.9927 40.003C17.0371 40.003 13.1703 38.83 9.88128 36.6324C6.5923 34.4347 4.02885 31.3112 2.51509 27.6566C1.00134 24.0021 0.605275 19.9808 1.37698 16.1012C2.14868 12.2215 4.0535 8.65788 6.85055 5.86083C9.6476 3.06378 13.2113 1.15897 17.0909 0.387264C20.9705 -0.384441 24.9918 0.0116259 28.6464 1.52538C32.3009 3.03913 35.4244 5.60258 37.6221 8.89156C39.8197 12.1805 40.9927 16.0473 40.9927 20.003C40.9927 25.3073 38.8855 30.3944 35.1348 34.1451C31.3841 37.8958 26.297 40.003 20.9927 40.003Z" fill="currentColor"/>
    <path d="M19 24.003L27 16.003" stroke="white" stroke-width="2" stroke-linecap="round"/>
    <path d="M15 20.003L19 24.003" stroke="white" stroke-width="2" stroke-linecap="round"/>
  `
};
